export default "__VITE_ASSET__1vqIyzk7__"